<div class="page-sub-title">{{ league?.eventName }}</div>

<div class="tabs">
    <button class="tab" [ngClass]="{ active: containerDisplay === 'LEADERBOARD' }" (click)="containerDisplay = 'LEADERBOARD'">Leaderboard</button>
    <button class="tab" [ngClass]="{ active: containerDisplay === 'WEEKLIST' }" (click)="containerDisplay = 'WEEKLIST'">Schedule</button>
    <button class="tab" [ngClass]="{ active: containerDisplay === 'FIELD' }" (click)="containerDisplay = 'FIELD'">Field</button>
  </div>

<div id="week-list-container" *ngIf="containerDisplay === 'WEEKLIST'">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="center">Week</th>
            <th>Event</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let week of leagueWeeks; let i = index" (click)="selectWeek(week)">
            <td class="center narrow">
              {{ leagueWeeks.length - i }}
            </td>
            <td>
              {{ week.golfCourseName }}
            </td>
          </tr>
        </tbody>
        </table>
    </div>

    <div *ngIf="canAddWeek">
        <button (click)="containerDisplay = 'CREATE'">Add Week</button>
    </div>
</div>

<div id="week-info-container" *ngIf="containerDisplay === 'WEEKINFO'">
    <div class="page-sub-title">{{ selectedWeek?.golfCourseName }}</div>
    <div>
        <app-weekly-round-list [leagueWeek]="selectedWeek"></app-weekly-round-list>
    </div>
</div>

<div id="field-container" *ngIf="containerDisplay === 'FIELD'">
  <app-field [league]="league"></app-field>
</div>

<div id="create-week-container" *ngIf="containerDisplay === 'CREATE'">
    <app-create-week [golfEventId]="eventId" (saved)="refreshWeeks()"></app-create-week>
</div>

<a class="button margin-top-small" href="{{paymentLink}}" target="_blank">Pay Entry Fee</a>